import React from 'react';
import ExpenseQueuePage from './expenseQueue/ExpenseQueuePage';
import { PAYMENT_MODE } from './expenseQueue/constants/modes';

// /profile/payment-approval — ใช้ตาราง/hook ชุดเดียวกับ ExpenseReview.js (expenseQueue/) ต่างกันแค่
// config ใน expenseQueue/constants/modes.js (flag หลักคือ payment_approval_status)
export default function PaymentApproval({ title }) {
  return <ExpenseQueuePage title={title} mode={PAYMENT_MODE} />;
}
